import AboutCardStyleWrapper from "./AboutCard.style";

const AboutCard = ({ title, text }) => {
  return (
    <AboutCardStyleWrapper className="about_us_text_card">
      <h3>
        {title}
      </h3>
      <p>{text}</p>
    </AboutCardStyleWrapper>
  );
};

export default AboutCard;
